export default [
  {
    _name: "CSidebarNav",
    _children: [
      {
        _name: "CSidebarNavItem",
        name: "Recognition Rates",
        to: "/recognition",
        icon: "cil-chart-line"
      },
      {
        _name: "CSidebarNavItem",
        name: "Invoice Volume",
        to: "/invoice-volume",
        icon: "cil-bar-chart"
      },
      {
        _name: "CSidebarNavItem",
        name: "Invoice List",
        to: "/invoices",
        icon: "cil-description"
      },
      {
        _name: "CSidebarNavItem",
        name: "Recognition Analytics",
        to: "/recognition-analytics",
        icon: "cil-list-high-priority"
      }
    ]
  }
];
